import React from 'react';

const TestCard = ({ test, onSelect, formatDate, formatDuration }) => {
  return (
    <div
      className={`test-card ${test.success ? 'success' : 'failure'}`}
      onClick={() => onSelect(test)}
    >
      <div className="test-card-header">
        <h3>{test.test_name}</h3>
        <span className={`status-badge ${test.success ? 'success' : 'failure'}`}>
          {test.success ? '✓ PASS' : '✗ FAIL'}
        </span>
      </div>
      <div className="test-card-body">
        <div className="test-meta">
          <span className="test-app">{test.app_name}</span>
          <span className="test-date">{formatDate(test.start_time)}</span>
        </div>
        <div className="test-stats">
          <span>{test.test_steps.length} steps</span>
          <span>{formatDuration(test.start_time, test.end_time)}</span>
        </div>
      </div>
    </div>
  );
};

export default TestCard;
